<script>
export default {
    name: 'CountBadge',

    functional: true,

    props: {
        count: {type: Number, default: null},
    },
};
</script>

<template functional>
    <span
        v-if="props.count > 0"
        v-tooltip
        class="badge badge-pill badge-danger"
        :class="data.staticClass"
        v-bind="data.attrs">
        {{ props.count }}
    </span>
</template>
